import userActions from '../../actions';

const statsByQuiz = (state = {}, action) => {
  switch (action.type) {
    case userActions.GET_USER_STATS_BY_CATEGORY_SUCCESS:
      return action.statsByQuiz.quizzes.reduce(
        ((items, stats) => {
          return { ...items, [stats.quiz]: stats };
        }), state);
    case userActions.LOGOUT_SUCCESS:
      return {};
    default:
      return state;
  }
};

export default statsByQuiz;
